import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Classroom } from 'types';

const useStyles = makeStyles((theme: Theme) => {
  return {
    dFlex: {
      display: 'flex',
    },
    pb2: {
      paddingBottom: theme.spacing(2),
    },
    pb4: {
      paddingBottom: theme.spacing(4),
    },
    label: {
      ...theme.typography.subtitle1,
    },
    panel: {
      height: '100%',
      border: `1px solid ${(theme.palette as any).grey[600]}`,
      '&:hover': {
        transform: 'scale(1.01, 1.01)',
        boxShadow: '0 1px 10px 2px rgb(0 0 0 / 20%)',
      },
    },
    curriculum: {
      width: '50px',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  };
});

const t = (key) => translate('ui', key);

type ClassroomProps = {
  classroom: Classroom;
};

const ClassroomCard: React.FC<ClassroomProps> = (props: ClassroomProps) => {
  const classroom = props.classroom;
  const classes = useStyles();
  return (
    <Card
      aria-label="notification-profile-card"
      className={classes.panel}
      style={{ borderTop: `20px solid ${classroom.color ?? 'red'}` }}
    >
      <CardContent>
        <Typography variant="h2" className={classes.pb4}>
          {classroom.name}
        </Typography>
        <Typography className={classes.pb2}>
          {t('home.educator')}:{' '}
          {classroom?.users && classroom.users.length > 0
            ? `${classroom.users[0].user.firstName} ${classroom.users[0].user.lastName}`
            : t('home.noEducators')}
        </Typography>
        <Typography className={classes.pb2}>
          {t('home.numOfStudents')}: {classroom.studentCount}
        </Typography>
        {/* <div className={classes.dFlex}>
          <Typography className={classes.dFlex}>{t('home.curriculums')}:</Typography>
          {classroom.licenseUsage?.map((license) => (
            <span key={license.productCurriculumId}>
              <img
                src={license.productCurriculum?.iconUrl as string}
                className={classes.curriculum}
              />
            </span>
          ))}
        </div> */}
      </CardContent>
    </Card>
  );
};

export default ClassroomCard;
